require("!!/usr/src/cube/node_modules/script-loader/addScript.js")(require("!!/usr/src/cube/node_modules/raw-loader/index.js!/usr/src/cube/src/legacy/common/ajax.legacy.js"))


//////////////////
// WEBPACK FOOTER
// ./src/legacy/common/ajax.legacy.js
// module id = 614
// module chunks = 31